export default __webpack_public_path__ + "static/media/amitChem.db47e4db.jpg";